import {useState} from 'react'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {NewParasiteTrackerMapContentItem} from '@/products/disease-map/parasite-tracker/new-parasite-map/types'
import {ParasiteTrackerMap as NewParasiteTrackerMap} from '@/products/disease-map/parasite-tracker/new-parasite-map'
import type {Block} from '@/services/kontent-ai/types'
import {ParasiteTrackerSidebar as NewParasiteTrackerSidebar} from '@/products/disease-map/parasite-tracker/new-parasite-map/new-sidebar'
import type {ParasiteTrackerSidebarContentItem} from '../parasite-tracker-sidebar/types'

export type ParasiteTrackerModuleContentItem = IContentItem<{
	parasiteTrackerMap: Elements.LinkedItemsElement<NewParasiteTrackerMapContentItem>
	parasiteTrackerSidePanel: Elements.LinkedItemsElement<ParasiteTrackerSidebarContentItem>
}>

export const ParasiteTrackerModuleBlock: Block<
	ParasiteTrackerModuleContentItem
> = ({
	block: {
		elements: {
			parasiteTrackerMap: [mapBlock],
			parasiteTrackerSidePanel: [sidePanelBlock],
		},
	},
	...context
}) => {
	const [error, setError] = useState(false)

	const [showSummaryText, setShowSummaryText] = useState<boolean | undefined>(
		false
	)
	const [reportedCases, setReportedCases] = useState<string>('')
	const [locationName, setLocationName] =
		useState<string>('the selected area')

	// eslint-disable-next-line react/jsx-no-useless-fragment -- remove when react types are fixed and can return null
	if (!(mapBlock && sidePanelBlock)) return <></>

	const Map = NewParasiteTrackerMap
	const Sidebar = NewParasiteTrackerSidebar

	return (
		<div className="flex flex-col md:flex-row">
			<div className="w-full md:w-2/3 md:flex-1">
				<Map
					block={mapBlock}
					error={error}
					setError={setError}
					setLocationName={setLocationName}
					setReportedCases={setReportedCases}
					setShowSummaryText={setShowSummaryText}
					theme={sidePanelBlock.elements.themeHexcode || '#2772ce'}
					{...context}
				/>
			</div>
			<div className="w-full md:w-1/3">
				<Sidebar
					block={{
						...sidePanelBlock,
					}}
					locationName={locationName}
					radius={mapBlock.elements.radius}
					reportedCases={reportedCases}
					setLocationName={setLocationName}
					setReportedCases={setReportedCases}
					setShowSummaryText={setShowSummaryText}
					showSummaryText={showSummaryText}
					{...context}
				/>
			</div>
		</div>
	)
}
